import httpClient from "./httpClient";

const END_POINT = "/api/users";
const createUser = (user) => httpClient.post(END_POINT, user);
const getAllUsers = (page, filterList) =>
  httpClient.get(END_POINT , {
    params: {
      page,
      ...filterList,
    },
  });
const getAllActiveUsers = () => httpClient.get(END_POINT + "/active");
const changePassword = (password, newpassword, c_newpassword) =>
  httpClient.post(END_POINT + "/change-password", {
    password,
    newpassword,
    c_newpassword,
  });
const getUser = () => httpClient.get(END_POINT + "/get-user");
const getUserById = (id) => httpClient.get(END_POINT + "/getById/" + id);
const UpdatePhoto = (image) =>
  httpClient.post(END_POINT + "/change-image", image);
const updateUserInfo = (user) => httpClient.post(END_POINT + "/update", user);
const searchUser = (name) => httpClient.get("/api/search/users/" + name);
const getFunctionsUser = () => httpClient.get("api/users/getFunctionsUser");
const updatePhoto = (photo) =>
  httpClient.post(END_POINT + "/change-image", photo);
const getActiveUsers = () => httpClient.get(END_POINT + "/getActiveUsers");
const getAgentsByDossiers = (dossiers) => httpClient.post(END_POINT + "/getAgentsByDossiers", dossiers);
const desactivateUsers = (selectedUsers) =>
  httpClient.post(END_POINT + "/desactivate", selectedUsers);
export {
  createUser,
  getAllUsers,
  changePassword,
  getUser,
  UpdatePhoto,
  updateUserInfo,
  getUserById,
  getAllActiveUsers,
  searchUser,
  getFunctionsUser,
  updatePhoto,
  getActiveUsers,
  getAgentsByDossiers,
  desactivateUsers
};
